// ============================================
// RECESSO ONLINE - Wild and Inspire
// Art. 54-bis Codice del Consumo
// Fase 2 — Backend Render + EmailJS
// ============================================

const EMAILJS_SERVICE_ID          = 'service_p50oqoj';
const EMAILJS_TEMPLATE_CLIENTE_ID = 'template_kk5h1d5';
const EMAILJS_TEMPLATE_STORE_ID   = 'template_0k1ty9n';
const EMAILJS_PUBLIC_KEY          = 'jeMsDX5QRl3eMzybQ';
const RENDER_VERIFICA             = 'https://recesso-backend.onrender.com/verifica-ordine';
const RENDER_CONFERMA             = 'https://recesso-backend.onrender.com/conferma-recesso';
//const RENDER_VERIFICA             = 'http://localhost:3000/verifica-ordine';
//const RENDER_CONFERMA             = 'http://localhost:3000/conferma-recesso';

// ============================================
// VARIABILI GLOBALI
// ============================================
let datiRecesso = {};
let articoliVerificati = [];

// ============================================
// HELPERS
// ============================================
// questa funzinoe: Usata per errori di validazione campi,Mostra il messaggio rosso sotto il campo specifico,Aggiunge bordo rosso al campo.
function mostraErrore(fieldId, messaggio) {
  const field = document.getElementById(fieldId);
  const existing = document.getElementById(fieldId + '-error');
  if (existing) existing.remove();
  const err = document.createElement('p');
  err.id = fieldId + '-error';
  err.style.cssText = 'color:#c0392b; font-size:0.85em; margin:4px 0 0 0;';
  err.textContent = messaggio;
  field.style.borderColor = '#c0392b';
  field.insertAdjacentElement('afterend', err);
}

// questa funzinoe: Pulisce gli errori di validazione campo
function rimuoviErrore(fieldId) {
  const field = document.getElementById(fieldId);
  const existing = document.getElementById(fieldId + '-error');
  if (existing) existing.remove();
  if (field) field.style.borderColor = '';
}

// questa funzione: Usata per errori dal backend,Mostra il messaggio nel div globale dello step
function mostraMessaggioGlobale(divId, messaggio, tipo = 'errore') {
  const div = document.getElementById(divId);
  if (!div) return;
  div.textContent = messaggio;
  div.style.display = 'block';
  div.style.backgroundColor = tipo === 'errore' ? '#fdecea' : '#eafaf1';
  div.style.color = tipo === 'errore' ? '#c0392b' : '#1e8449';
  div.style.border = tipo === 'errore' ? '1px solid #e74c3c' : '1px solid #27ae60';
}

// Questa funzione: Traduce il motivo del backend in messaggio localizzato, Sempre usata insieme a mostraMessaggioGlobale.
function traduciErrore(motivo, fallback) {
  const chiave = `errori_${motivo}`;
  return window.recessoI18n?.[chiave] || fallback;
}

function emailRicevuta() {
  // Restituisce email alternativa se compilata, altrimenti email ordine
  return datiRecesso.emailAlt || datiRecesso.email;
}

// ============================================
// BOTTONE VERIFICA ORDINE
// ============================================
document.getElementById('btn-verifica').addEventListener('click', async () => {
  const nome     = document.getElementById('r-nome').value.trim();
  const ordine   = document.getElementById('r-ordine').value.trim();
  const email    = document.getElementById('r-email').value.trim();
  const emailAlt = document.getElementById('r-email-alt').value.trim();

  // Reset errori
  rimuoviErrore('r-nome');
  rimuoviErrore('r-ordine');
  rimuoviErrore('r-email');
  rimuoviErrore('r-email-alt');

  // Validazione
  let hasError = false;
  if (!nome)   { mostraErrore('r-nome', window.recessoI18n.err_nome); hasError = true; }
  if (!ordine) { mostraErrore('r-ordine', window.recessoI18n.err_ordine); hasError = true; }
  if (!email)  { mostraErrore('r-email', window.recessoI18n.err_email); hasError = true; }
  else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    mostraErrore('r-email', window.recessoI18n.err_email_formato); hasError = true;
  }
  // Valida email alternativa solo se compilata
if (emailAlt && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(emailAlt)) {               
    mostraErrore('r-email-alt', window.recessoI18n.err_email_alt_formato); hasError = true;
  }
  if (hasError) return;

  // Stato caricamento
  const msg = document.getElementById('r-verifica-msg');
  const btn = document.getElementById('btn-verifica');
  btn.disabled = true;
  btn.textContent = window.recessoI18n.btn_loading;
  msg.style.display = 'none';
  document.getElementById('r-prodotti-container').style.display = 'none';
  document.getElementById('btn-step1').style.display = 'none';

  try {
    const res = await fetch(RENDER_VERIFICA, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ordine, email })
    });
    const data = await res.json();

    if (data.valido) {
      // Nascondi bottone verifica
      btn.style.display = 'none';

      // Blocca campi verificati
      ['r-ordine', 'r-email'].forEach(id => {
        const el = document.getElementById(id);
        el.readOnly = true;
        el.style.background = '#f0f0f0';
        el.style.color = '#888';
      });

      // Salva dati globali
      articoliVerificati = data.articoli;
      datiRecesso = { nome, ordine, email, emailAlt: emailAlt || null };

      // Messaggio successo
      msg.style.cssText = 'display:block; padding:12px; border-radius:6px; margin-bottom:16px; font-size:0.9em; background:#d4edda; color:#155724; border:1px solid #c3e6cb;';
      msg.textContent = window.recessoI18n.msg_trovato;

      // Genera checkbox articoli
      const lista = document.getElementById('r-prodotti-lista');
      lista.innerHTML = '';
      articoliVerificati.forEach((art, i) => {
        const sku = art.sku && art.sku !== '—' ? ` — SKU: ${art.sku}` : '';
        lista.innerHTML += `
          <label style="display:flex; align-items:center; gap:10px; padding:10px; border:1px solid #ddd; border-radius:6px; margin-bottom:8px; cursor:pointer;">
            <input type="checkbox" class="r-articolo-check" data-index="${i}"
              style="width:18px; height:18px; cursor:pointer;">
            <span>${art.nome}${sku} — Qtà: ${art.quantita}</span>
          </label>
        `;
      });

      document.getElementById('r-prodotti-container').style.display = 'block';

      // Bottone Procedi
      const btnStep1 = document.getElementById('btn-step1');
      btnStep1.style.display = 'block';
      btnStep1.disabled = true;
      btnStep1.style.background = '#999';
      btnStep1.style.cursor = 'not-allowed';

      document.querySelectorAll('.r-articolo-check').forEach(cb => {
        cb.addEventListener('change', () => {
          const selezionati = document.querySelectorAll('.r-articolo-check:checked').length;
          btnStep1.disabled = selezionati === 0;
          btnStep1.style.background = selezionati > 0 ? '#000' : '#999';
          btnStep1.style.cursor = selezionati > 0 ? 'pointer' : 'not-allowed';
          document.getElementById('r-prodotti-error').style.display = 'none';
        });
      });

    } else {
      btn.style.display = 'block';
      msg.style.cssText = 'display:block; padding:12px; border-radius:6px; margin-bottom:16px; font-size:0.9em; background:#f8d7da; color:#721c24; border:1px solid #f5c6cb;';
      //msg.textContent = data.messaggio || window.recessoI18n.msg_errore;
      mostraMessaggioGlobale('r-verifica-msg', traduciErrore(data.motivo, data.messaggio));
    }

  } catch (err) {
    msg.style.cssText = 'display:block; padding:12px; border-radius:6px; margin-bottom:16px; font-size:0.9em; background:#f8d7da; color:#721c24; border:1px solid #f5c6cb;';
    msg.textContent = window.recessoI18n.msg_servizio_ko;
    console.error('Errore verifica:', err);
  } finally {
    btn.disabled = false;
    btn.textContent = window.recessoI18n.btn_verifica;
  }
});

// ============================================
// BOTTONE PROCEDI — Step 1 → Step 2
// ============================================
document.getElementById('btn-step1').addEventListener('click', () => {
  const selezionati = [...document.querySelectorAll('.r-articolo-check:checked')]
    .map(cb => articoliVerificati[parseInt(cb.dataset.index)]);

  if (selezionati.length === 0) {
    document.getElementById('r-prodotti-error').style.display = 'block';
    return;
  }

  datiRecesso.articoli = selezionati;

  // Riepilogo dati cliente
  document.getElementById('r-riepilogo').innerHTML = `
    <strong>${window.recessoI18n.label_nome}</strong> ${datiRecesso.nome}<br>
    <strong>${window.recessoI18n.label_ordine}</strong> #${datiRecesso.ordine}<br>
    <strong>${window.recessoI18n.label_email}</strong> ${datiRecesso.email}
  `;

  // Box email ricevuta
  const emailRic = emailRicevuta();
  document.getElementById('r-riepilogo-email-ricevuta').innerHTML =
    `📧 <strong>${window.recessoI18n.label_email_ricevuta}</strong> ${emailRic}`;

  // Articoli selezionati
  const articoliHtml = selezionati.map(a => {
    const sku = a.sku && a.sku !== '—' ? ` — SKU: ${a.sku}` : '';
    return `• ${a.nome}${sku} — Qtà: ${a.quantita}`;
  }).join('<br>');
  document.getElementById('r-articoli-step2').innerHTML = articoliHtml;

  document.getElementById('step-1').style.display = 'none';
  document.getElementById('step-2').style.display = 'block';
  window.scrollTo({ top: 0, behavior: 'smooth' });
});

// ============================================
// BOTTONE INDIETRO — Step 2 → Step 1
// ============================================
document.getElementById('btn-indietro').addEventListener('click', () => {
  document.getElementById('step-2').style.display = 'none';
  document.getElementById('step-1').style.display = 'block';
  window.scrollTo({ top: 0, behavior: 'smooth' });

  ['r-ordine', 'r-email'].forEach(id => {
    const el = document.getElementById(id);
    el.readOnly = false;
    el.style.background = '';
    el.style.color = '';
  });

  document.getElementById('btn-verifica').style.display = 'block';
  document.getElementById('btn-step1').style.display = 'none';
  document.getElementById('r-prodotti-container').style.display = 'none';
  document.getElementById('r-verifica-msg').style.display = 'none';
  document.getElementById('r-conferma-msg').style.display = 'none';
});

// ============================================
// BOTTONE CONFERMA — Step 2 → Step 3
// ============================================
document.getElementById('btn-step2').addEventListener('click', async () => {
  const btn = document.getElementById('btn-step2');
  const msg = document.getElementById('r-conferma-msg');

  // Stato caricamento
  btn.disabled = true;
  btn.textContent = window.recessoI18n.btn_conferma_loading;
  msg.style.display = 'none';

  try {
    // Genera protocollo e timestamp
    const now = new Date();
    const pad = n => String(n).padStart(2, '0');
    const dataStr = `${now.getFullYear()}${pad(now.getMonth()+1)}${pad(now.getDate())}`;
    const timeStr = `${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
    const protocollo = `REC-${dataStr}-${datiRecesso.ordine}-${timeStr}`;
    const timestampLeggibile = `${pad(now.getDate())}/${pad(now.getMonth()+1)}/${now.getFullYear()} ${window.recessoI18n.label_timestamp3} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;

    datiRecesso.protocollo = protocollo;
    datiRecesso.timestamp  = timestampLeggibile;  
    //console.log('nome:', datiRecesso.nome) //4 debug only

    // Chiamata /conferma-recesso
    const res = await fetch(RENDER_CONFERMA, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ordine:               datiRecesso.ordine,
        email:                datiRecesso.email,
        articoli_selezionati: datiRecesso.articoli.map(a => ({ id: a.id, nome: a.nome })),
        nome:                 datiRecesso.nome,  // add new 4 log
        protocollo:           datiRecesso.protocollo // add new 4 log
      })
    });
    const data = await res.json();

    if (!data.valido) {
      msg.style.cssText = 'display:block; padding:12px; border-radius:6px; margin-bottom:16px; font-size:0.9em; background:#f8d7da; color:#721c24; border:1px solid #f5c6cb;';
      //msg.textContent = data.messaggio || window.recessoI18n.msg_errore;
      mostraMessaggioGlobale('r-conferma-msg', traduciErrore(data.motivo, data.messaggio));
      return;
    }

    // Articoli per ricevuta
    const articoliHtml = datiRecesso.articoli.map(a => {
      const sku = a.sku && a.sku !== '—' ? ` — SKU: ${a.sku}` : '';
      return `• ${a.nome}${sku} — Qtà: ${a.quantita}`;
    }).join('<br>');

    // Popola Step 3
    const emailRic = emailRicevuta();
    document.getElementById('r-protocollo').innerHTML =
      `${window.recessoI18n.label_protocollo} <strong>${protocollo}</strong>`;
    document.getElementById('r-timestamp').innerHTML =
      `${window.recessoI18n.label_timestamp} <strong>${timestampLeggibile}</strong> ${window.recessoI18n.label_timestamp2}`;
    document.getElementById('r-ricevuta-dati').innerHTML = `
      <strong>${window.recessoI18n.label_nome}</strong> ${datiRecesso.nome}<br>
      <strong>${window.recessoI18n.label_ordine}</strong> #${datiRecesso.ordine}<br>
      <strong>${window.recessoI18n.label_email}</strong> ${datiRecesso.email}
    `;
    document.getElementById('r-ricevuta-email-ricevuta').innerHTML =
      `📧 <strong>${window.recessoI18n.label_email_ricevuta}</strong> ${emailRic}`;
    document.getElementById('r-articoli-step3').innerHTML = articoliHtml;

    document.getElementById('step-2').style.display = 'none';
    document.getElementById('step-3').style.display = 'block';
    window.scrollTo({ top: 0, behavior: 'smooth' });

    // Email — commentata per debug
    await inviaEmail(datiRecesso);

  } catch (err) {
    msg.style.cssText = 'display:block; padding:12px; border-radius:6px; margin-bottom:16px; font-size:0.9em; background:#f8d7da; color:#721c24; border:1px solid #f5c6cb;';
    msg.textContent = window.recessoI18n.msg_servizio_ko;
    console.error('Errore conferma:', err);
  } finally {
    btn.disabled = false;
    btn.textContent = window.recessoI18n.btn_conferma_loading.replace('⏳ ', '') ;
    // ripristina testo — aggiungi chiave btn_conferma a i18n se preferisci
  }
});

// ============================================
// INVIO EMAIL via EmailJS — commentato per debug
// ============================================
async function inviaEmail(dati) {
  const articoliTesto = dati.articoli.map(a => {
    const sku = a.sku && a.sku !== '—' ? ` — SKU: ${a.sku}` : '';
    return `${a.nome}${sku} — Qtà: ${a.quantita}`;
  }).join('\n');

  try {
    await emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_CLIENTE_ID, {
      nome:           dati.nome,
      ordine:         dati.ordine,
      email_cliente:  dati.email,        // email ordine — mostrata nel corpo
      email_ricevuta: emailRicevuta(),   // email opzionale — usata solo per l'invio
      protocollo:     dati.protocollo,
      timestamp:      dati.timestamp,
      articoli:       articoliTesto,
      // testi tradotti
      email_titolo:       window.recessoI18n.email_titolo,
      email_nota_legale:  window.recessoI18n.email_nota_legale,
      email_timestamp1:   window.recessoI18n.email_timestamp1,
      email_timestamp2:   window.recessoI18n.email_timestamp2,
      email_timestamp3:   window.recessoI18n.email_timestamp3,
      email_articoli:     window.recessoI18n.email_articoli,
      email_nb:           window.recessoI18n.email_nb,
      email_label_nome:   window.recessoI18n.email_label_nome,
      email_label_ordine: window.recessoI18n.email_label_ordine,
      email_label_email:  window.recessoI18n.email_label_email
    }, EMAILJS_PUBLIC_KEY);

    await emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_STORE_ID, {
      nome:       dati.nome,
      ordine:     dati.ordine,
      email:      dati.email,
      protocollo: dati.protocollo,
      timestamp:  dati.timestamp,
      articoli:   articoliTesto
    }, EMAILJS_PUBLIC_KEY);

  } catch (err) {
    console.error('Errore invio email:', err);
  }
}
